export default {
  methods: {
    getLocationActiveText() {
      return this.$t('Webportal.Location') + ' ' + this.$t('Webportal.Active');
    },
    getLocationInactiveText() {
      return this.$t('Webportal.Location') + ' ' + this.$t('Webportal.Inactive');
    }
  }
}

// Usage:
// import ActiveInactiveTexts from '@/mixins/ActiveInactiveTexts';
// mixins: [ ActiveInactiveTexts ],
